export var studentIdWhitelist = [6952847, 3047711, 5167001, 5846998, 6037438];
export var whiteListedEvolveUser = 'skillian26';
export var whiteListedDemoUsername = 'itesting';
